import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import styles from './modal.module.css';
import { CloseButton } from '../../buttons';
export function Modal(_a) {
    var open = _a.open, onClose = _a.onClose, _b = _a.zIndex, zIndex = _b === void 0 ? 100 : _b, _c = _a.type, type = _c === void 0 ? 'medium' : _c, children = _a.children, fixedCloseButton = _a.fixedCloseButton;
    var modalRef = useRef(null);
    useEffect(function () {
        var _a;
        (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
        window.document.body.classList.toggle('modalOpen', open);
        return function () { return window.document.body.classList.remove('modalOpen'); };
    }, [open]);
    return ReactDOM.createPortal(React.createElement("dialog", { className: classNames(styles.modalDialog, "kplr_modalDialog"), open: open, style: { zIndex: zIndex } },
        React.createElement("div", { className: styles.modalOverlay, onClick: onClose }),
        React.createElement("div", { ref: modalRef, className: classNames(styles.modalContainer, styles[type]) },
            React.createElement("div", { className: styles.modalBackground },
                React.createElement(CloseButton, { sticky: fixedCloseButton, onClick: onClose }),
                children))), window.document.body);
}
export default Modal;
